import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { DashBoardService } from 'src/app/service/dashboard.service';
import { DataSharingService } from 'src/app/Service/datasharing.service';

@Component({
  selector: 'app-card-child-data',
  templateUrl: './card-child-data.component.html'
})
export class CardChildDataComponent implements OnInit, OnChanges {

  // Property declaration
  @Input() Index;
  DashBoardvalueDetails: any;
  DashboarddataList: any;
  errorMsg: any;
  isCalledfirsttime: number = 0;

  constructor(private dataSharingService: DataSharingService, private dashboardservice: DashBoardService) {
    this.dataSharingService.DashboardData.subscribe(value => {
      this.DashboarddataList = value;
    });
  }

  ngOnInit(): void {


  }

  // called when change any Input parameter
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {

  }

  UpdateValue(value, Index) {
    this.DashboarddataList[Index].MeterValuesList[0] = value;
  }

}
